import { defineMessages } from "react-intl";

export const scope = "app.containers.HomePage";

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: "Forecast"
  },
  marketForecast: {
    id: `${scope}.marketForecast`,
    defaultMessage:
      "Your Expected S&amp;P 500<sup>&reg;</sup> Return<sup>1</sup>"
  },
  participationRate: {
    id: `${scope}.participationRate`,
    defaultMessage: "Participation Rate"
  },
  annualSpread: {
    id: `${scope}.annualSpread`,
    defaultMessage: "Annual Spread"
  },
  excludeDividend: {
    id: `${scope}.excludeDividend`,
    defaultMessage: "Exclude Dividends<sup>2</sup>"
  },
  calculate: {
    id: `${scope}.calculate`,
    defaultMessage: "Calculate"
  },
  reset: {
    id: `${scope}.reset`,
    defaultMessage: "Reset Values"
  },
  percentageSymbol: {
    id: `${scope}.percentageSymbol`,
    defaultMessage: "%"
  },
  expectedProductReturn: {
    id: `${scope}.expectedProductReturn`,
    defaultMessage: "Expected Product Return Using Assumptions Above<sup>3</sup>"
  },
  disclaimerOne: {
    id: `${scope}.disclaimerOne`,
    defaultMessage: "<sup>1</sup> Reflects level assumed annual return.",
  },
  disclaimerTwo: {
    id: `${scope}.disclaimerTwo`,
    defaultMessage: '<sup>2</sup> Selecting "Yes" reduces Your Expected S&amp;P 500<sup>&reg;</sup> Return by 2.00% to reflect the dividend yield and convert to the Price Return index used in FIAs.',
  },
  disclaimerThree: {
    id: `${scope}.disclaimerThree`,
    defaultMessage: '<sup>3</sup>  Expected Product Return is not an actual return but is a hypothetical or simulated return for illustration purposes.',
  },
  disclaimerLabel: {
    id: `${scope}.disclaimerLabel`,
    defaultMessage: 'Access current Wall Street Forecasts and Capital Market Assumptions by clicking on the links below:',
  }
});
